import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import { api } from "./api";

export type EffortUnit = "points" | "hours";

/**
 * The workspace's chosen display unit for task effort estimates. Reads the
 * shared `/api/workspace` query (deduped across every card/detail that calls
 * this), defaulting to "points" until it loads or when unset.
 */
export function useEffortUnit(): EffortUnit {
  const ws = useQuery({
    queryKey: queryKeys.workspace(),
    queryFn: api.workspace,
    staleTime: 5 * 60_000,
  });
  return ws.data?.effortUnit ?? "points";
}

/**
 * Render an estimate in the workspace unit: `5 pts` or `5h`. Integers print
 * bare; fractional values keep one decimal. Returns null for an unset estimate
 * so callers can skip the badge entirely.
 */
export function formatEffort(
  estimate: number | null | undefined,
  unit: EffortUnit,
): string | null {
  if (estimate == null) return null;
  const n = Number.isInteger(estimate) ? String(estimate) : estimate.toFixed(1);
  return unit === "hours" ? `${n}h` : `${n} pts`;
}
